import React from 'react'
import { Stack } from 'react-bootstrap'
import type { MutationConfig } from '@ztechapps/common.utils'
import { formatMoney, formatPercent } from '@ztechapps/common.utils'
import { InlineInput, NumberInlineInput } from '@ztechapps/webui.input'
import type { Invoice, InvoiceItem } from '@ztechapps/totalmilk-payme.contract'
import { DeleteItemButton } from './DeleteItemButton'

export type ListRowProps = {
  updateMutationConfig: MutationConfig
  deleteMutationConfig: MutationConfig
  canEdit: boolean
  invoice: Partial<Invoice>
} & InvoiceItem
export const ListRow = (props: ListRowProps) => {
  const canEdit = props.canEdit
  //const { invoice, _id, description, name, , discountAmount = 0, amount,  } = props || {}

  const inputConfig = (name: string) => {
    return {
      canEdit,
      mutationConfig: props.updateMutationConfig, //queries?.updateInvoice_itemsConfig,
      initialValues: { _id: props?.invoice?._id, [`${name}`]: props[`${name}`] },
      updateParams: ({ updatedValue }) => {
        return {
          input: {
            [`${name}`]: updatedValue,
          },
          filter: {
            _id: props?.invoice?._id,
            'items._id': props._id,
          },
        }
      },
      name,
    }
  }

  return (
    <tr key={props._id}>
      <td>
        <Stack>
          <div>
            <InlineInput {...inputConfig('name')} />
          </div>
          <small className="fs-italic">
            <InlineInput {...inputConfig('description')} />
          </small>
        </Stack>
      </td>
      <td className="text-end">
        <InlineInput {...inputConfig('quantity')} />
      </td>
      <td className="text-end">
        <InlineInput
          {...inputConfig('price')}
          parentInputComponent={NumberInlineInput}
          displayContent={(value) => formatMoney(value)}
        />
      </td>
      <td className="text-end">
        <InlineInput
          {...inputConfig('discountPercent')}
          parentInputComponent={NumberInlineInput}
          displayContent={(value) => formatPercent(value)}
        />
        <div className="fs-italic text-warning">
          <small>({formatMoney(props.discountAmount)})</small>
        </div>
      </td>
      <td className="text-end">
        <h4>{formatMoney(props.amount)}</h4>
      </td>
      <td className="text-end">
        <DeleteItemButton
          itemId={props._id}
          invoiceId={props?.invoice?._id}
          name={props.name}
          disabled={!canEdit}
          deleteMutationConfig={props.deleteMutationConfig}
        />
      </td>
    </tr>
  )
}
